var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.117 13.188l-5.411-5.411 5.411-5.412zm-16.213.799l5.441-5.441 1.907 1.89c.22.218.576.218.796-.002l1.86-1.859 5.41 5.412zm-.798-.799V2.36l5.437 5.39zM17.319 1.567L9.647 9.238 1.91 1.567zm.234-1.13H1.67c-.933 0-1.693.76-1.693 1.694v11.291c0 .93.757 1.694 1.693 1.694h15.883c.93 0 1.693-.758 1.693-1.694V2.132c0-.931-.757-1.694-1.693-1.694z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.4e7fbd4b989c27d81c7db767e97b5ffe.svg";
export { ForwardRef as ReactComponent };